__turbopack_context__.v({
  "counter": "car-gallery-module__2qL4JG__counter",
  "gallery": "car-gallery-module__2qL4JG__gallery",
  "media": "car-gallery-module__2qL4JG__media",
  "nav": "car-gallery-module__2qL4JG__nav",
  "next": "car-gallery-module__2qL4JG__next",
  "noPhoto": "car-gallery-module__2qL4JG__noPhoto",
  "photo": "car-gallery-module__2qL4JG__photo",
  "prev": "car-gallery-module__2qL4JG__prev",
  "slide": "car-gallery-module__2qL4JG__slide",
  "stage": "car-gallery-module__2qL4JG__stage",
  "thumb": "car-gallery-module__2qL4JG__thumb",
  "thumbImg": "car-gallery-module__2qL4JG__thumbImg",
  "thumbOn": "car-gallery-module__2qL4JG__thumbOn",
  "thumbs": "car-gallery-module__2qL4JG__thumbs",
  "track": "car-gallery-module__2qL4JG__track",
});
